import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-project-simple-card',
    templateUrl: './project-simple-card.component.html',
    styleUrls: ['./project-simple-card.component.scss']
})
export class ProjectSimpleCardComponent implements OnInit {
    @Input()
    projectName: string;

    constructor() {}

    ngOnInit() {}
}
